import { action } from "@ember/object"
import Component from "@glimmer/component"
import { toDown, toLeft, toRight, toUp } from "ember-animated/transitions/move-over"
import { includes, pull, uniq } from "lodash-es"
import { tracked } from "tracked-built-ins"

let headerNameStack: Array<string> = []
let bodyNameStack: Array<string> = []

interface Signature {
  Args: {
    toggleCardMenu: () => void
    usedAs: string
    addCardToBottom: () => void
    permissions: Array<string>
  }
}

export default class AddCardMenu extends Component<Signature> {
  @tracked menuName: string = "PRIMARY"
  headerNameStack = ["planner/menus/add-card/primary/add-card-title"]
  bodyNameStack = ["planner/menus/add-card/primary/add-card-body"]

  headerAnimationRules({ oldItems, newItems }) {
    let newVal = newItems[0]
    let oldVal = oldItems[0]
    if (oldVal === undefined || oldVal === null) return toUp
    if (newVal === undefined || newVal === null) return toUp
    let newValInner = Object.getOwnPropertySymbols(newVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )
    let oldValInner = Object.getOwnPropertySymbols(oldVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )
    if (newValInner === undefined || oldValInner === undefined)
      throw Error("The inner name might have changed")
    let newComponentName = newVal[newValInner].name
    let oldComponentName = oldVal[oldValInner].name
    // we're going backwards
    if (
      includes(headerNameStack, newComponentName) &&
      includes(headerNameStack, oldComponentName)
    ) {
      pull(headerNameStack, oldComponentName)
      return toDown
    } else {
      headerNameStack.push(newComponentName)
      return toUp
    }
  }

  animationRules({ oldItems, newItems }) {
    let newVal = newItems[0]
    let oldVal = oldItems[0]
    if (oldVal === undefined || oldVal === null) return toLeft
    if (newVal === undefined || newVal === null) return toLeft
    let newValInner = Object.getOwnPropertySymbols(newVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )
    let oldValInner = Object.getOwnPropertySymbols(oldVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )
    if (newValInner === undefined || oldValInner === undefined)
      throw Error("The inner name might have changed")
    let newComponentName = newVal[newValInner].name
    let oldComponentName = oldVal[oldValInner].name

    // For the first check, there's an odd case where the new is null and then the new is present and the old is null
    // and this just makes sure we're always going the right way if we're returning home.
    if (
      newComponentName === "planner/menus/add-card/primary/add-card-body" ||
      (includes(bodyNameStack, newComponentName) && includes(bodyNameStack, oldComponentName))
    ) {
      // we're going backwards
      pull(bodyNameStack, oldComponentName)
      return toRight
    } else {
      bodyNameStack.push(newComponentName)
      bodyNameStack = uniq(bodyNameStack)
      return toLeft
    }
  }

  @action
  goToAddCard() {
    this.menuName = "ADD_GC_CARD"
  }

  @action
  backToPrimaryMenu() {
    this.menuName = "PRIMARY"
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::AddCard": typeof AddCardMenu
  }
}
